

import {withRouter} from "react-router-dom";

const Navigator = (props) => {
        this.history.push(props.sti);
}

export default withRouter(Navigator)